import type { GalleryImageData } from "../image-gallery/image-gallery.types";
import type {
  ProductMediaGalleryMicrocopies,
  ProductMediaGalleryVideoItem,
} from "./product-media-gallery.types";

export function buildMediaGalleryImages(
  productName: string,
  mainAsset?: string,
  assetViews?: string[],
  beautyshots?: string[],
  videos?: ProductMediaGalleryVideoItem[]
): GalleryImageData[] {
  const images: GalleryImageData[] = [];

  if (mainAsset) {
    images.push({ src: mainAsset, alt: `${productName} - main view` });
  }

  assetViews?.forEach((url, i) => {
    if (url) {
      images.push({ src: url, alt: `${productName} - view ${i + 1}` });
    }
  });

  beautyshots?.forEach((url, i) => {
    if (url) {
      images.push({
        src: url,
        alt: `${productName} - beauty ${i + 1}`,
      });
    }
  });

  videos?.forEach((video, i) => {
    const thumbnailSrc = video.thumbnailSrc?.trim();
    const playerUrl = video.playerUrl.trim();

    if (!playerUrl) {
      return;
    }

    images.push({
      alt: video.alt || `${productName} - video ${i + 1}`,
      mediaType: "video",
      src: thumbnailSrc || playerUrl,
      thumbnailSrc: thumbnailSrc || playerUrl,
      videoUrl: playerUrl,
    });
  });

  return images;
}

const DEFAULT_MICROCOPIES: ProductMediaGalleryMicrocopies = {
  viewGallery: "View Gallery",
  previous: "Previous",
  next: "Next",
  close: "Close",
  imageCounter: "{current}/{total}",
  playVideo: "Play video",
};

export function resolveGalleryMicrocopies(
  overrides?: Partial<ProductMediaGalleryMicrocopies>
): ProductMediaGalleryMicrocopies {
  return { ...DEFAULT_MICROCOPIES, ...overrides };
}
